<app-wrapper>

  <div>
    <div class="mb-4">
      <div class="row g-3">
        <div class="col-auto">
          <h2>
            <div class="d-inline pe-2 cursor-pointer" (click)="back()" title="Назад">
              <i class="fa-solid fa-arrow-left"></i>
            </div>
            Категория "{{category.name}}"
          </h2>
        </div>
        <div class="col-auto flex-grow-1">
        </div>
        <div class="col-auto">
          <button (click)="save()" [disabled]="form.invalid || isBusy || isLoading" class="btn btn-primary">
            @if (isBusy) {
            <i class="fa-solid fa-spinner fa-spin me-2"></i>
            }
            @if (!isBusy) {
            <i class="fa-solid fa-save me-2"></i>
            }
            Сохранить
          </button>
        </div>
      </div>
    </div>

    <div class="row g-5">
      <div class="col-12">
        <form #form="ngForm" class="card p-4">
          <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li ngbNavItem>
              <button ngbNavLink>Есть в наличии</button>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-md-6">
                    <input type="text" [(ngModel)]="searchLeftText" name="searchLeft" (keyup.enter)="searchLeft()"
                      class="form-control mb-2" placeholder="Поиск">
                    <div [ngClass]="{'scrolled-container': items.length > 30}" cdkScrollable>

                      <table class="w-100">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Название</th>
                            <th>Сортировка<br />
                              <small class="text-danger">
                                (для применения нажмите Enter)
                              </small>
                            </th>
                          </tr>
                        </thead>
                        <tbody cdkDropList (cdkDropListDropped)="drop(true, $event)">
                          @for (item of hasInStoreItems; track item; let i = $index) {
                          <tr [attr.data-name-left]="item.name.toLowerCase()" cdkDrag>
                            <td>
                              <i class="fa-solid"
                                [ngClass]="{'text-danger': !item.isPublished, 'text-success':item.isPublished, 'fa-check': item.isPublished, 'fa-times': !item.isPublished}"
                                [title]="item.isPublished ? 'Опубликована' : 'Снята с публикации'"></i>
                            </td>
                            <td>
                              {{ item.name }}
                            </td>
                            <td style="width: 100px;">
                              <input type="number" min="0" step="1" [value]="item.order"
                                (keyup.enter)="setValue(item, $event)" class="form-control mb-2">
                            </td>
                          </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>

                  @if (items.length > 30) {
                  <div class="col-md-6 d-none d-md-block">
                    <input type="text" [(ngModel)]="searchRightText" name="searchRight" (keyup.enter)="searchRight()"
                      class="form-control mb-2" placeholder="Поиск">
                    <div class="scrolled-container" cdkScrollable>
                      <table class="w-100">
                        <thead>
                          <tr>
                          <tr>
                            <th></th>
                            <th>Название</th>
                            <th>Сортировка<br />
                              <small class="text-danger">
                                (для применения нажмите Enter)
                              </small>
                            </th>
                          </tr>
                        </thead>
                        <tbody cdkDropList (cdkDropListDropped)="drop(true, $event)">
                          @for (item of hasInStoreItems; track item; let i = $index) {
                          <tr [attr.data-name-right]="item.name.toLowerCase()" cdkDrag>
                            <td>
                              <i class="fa-solid"
                                [ngClass]="{'text-danger': !item.isPublished, 'text-success':item.isPublished, 'fa-check': item.isPublished, 'fa-times': !item.isPublished}"
                                [title]="item.isPublished ? 'Опубликована' : 'Снята с публикации'"></i>
                            </td>
                            <td>
                              {{ item.name }}
                            </td>
                            <td style="width: 100px;">
                              <input type="number" min="0" step="1" [value]="item.order"
                                (keyup.enter)="setValue(item, $event)" class="form-control mb-2">
                            </td>
                          </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  }
                </div>
              </ng-template>
            </li>
            <li ngbNavItem>
              <button ngbNavLink>Отсутствуют</button>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-md-6">
                    <input type="text" [(ngModel)]="searchLeftText" name="searchLeft" (keyup.enter)="searchLeft()"
                      class="form-control mb-2" placeholder="Поиск">
                    <div [ngClass]="{'scrolled-container': items.length > 30}" cdkScrollable>
                      <table class="w-100">
                        <thead>
                          <tr>
                            <th></th>
                            <th>Название</th>
                            <th>Сортировка<br />
                              <small class="text-danger">
                                (для применения нажмите Enter)
                              </small>
                            </th>
                          </tr>
                        </thead>
                        <tbody cdkDropList (cdkDropListDropped)="drop(false, $event)">
                          @for (item of hasNoStoreItems; track item; let i = $index) {
                          <tr [attr.data-name-left]="item.name.toLowerCase()" cdkDrag>
                            <td>
                              <i class="fa-solid"
                                [ngClass]="{'text-danger': !item.isPublished, 'text-success':item.isPublished, 'fa-check': item.isPublished, 'fa-times': !item.isPublished}"
                                [title]="item.isPublished ? 'Опубликована' : 'Снята с публикации'"></i>
                            </td>
                            <td>
                              {{ item.name }}
                            </td>
                            <td style="width: 100px;">
                              <input type="number" min="0" step="1" [value]="item.order"
                                (keyup.enter)="setValue(item, $event)" class="form-control mb-2">
                            </td>
                          </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>

                  @if (items.length > 30) {
                  <div class="col-md-6 d-none d-md-block">
                    <input type="text" [(ngModel)]="searchRightText" name="searchRight" (keyup.enter)="searchRight()"
                      class="form-control mb-2" placeholder="Поиск">
                    <div class="scrolled-container" cdkScrollable>
                      <table class="w-100">
                        <thead>
                          <tr>
                          <tr>
                            <th></th>
                            <th>Название</th>
                            <th>Сортировка<br />
                              <small class="text-danger">
                                (для применения нажмите Enter)
                              </small>
                            </th>
                          </tr>
                        </thead>
                        <tbody cdkDropList (cdkDropListDropped)="drop(false, $event)">
                          @for (item of hasNoStoreItems; track item; let i = $index) {
                          <tr [attr.data-name-right]="item.name.toLowerCase()" cdkDrag>
                            <td>
                              <i class="fa-solid"
                                [ngClass]="{'text-danger': !item.isPublished, 'text-success':item.isPublished, 'fa-check': item.isPublished, 'fa-times': !item.isPublished}"
                                [title]="item.isPublished ? 'Опубликована' : 'Снята с публикации'"></i>
                            </td>
                            <td>
                              {{ item.name }}
                            </td>
                            <td style="width: 100px;">
                              <input type="number" min="0" step="1" [value]="item.order"
                                (keyup.enter)="setValue(item, $event)" class="form-control mb-2">
                            </td>
                          </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  }
                </div>
              </ng-template>
            </li>
          </ul>

          <div [ngbNavOutlet]="nav"></div>
        </form>
      </div>
    </div>
    @if (isLoading) {
    <div class="overlay">
      <i class="fa-solid fa-spinner fa-spin fs-2"></i>
    </div>
    }
  </div>
</app-wrapper>